import React            from 'react';
import {
    Route,
    NavLink }           from "react-router-dom";

import * as images      from '../images';
import Role             from '../utils/Role';

import NewLink          from './NewLink';
import Submissions      from './Submissions';

import App              from '../App';

export const Index = ( app:App ) : Role => {
    const roleRoot          = "/Clerk";
    const menuLinkClassName = "menu__link";
    const menuItems         = [
        <div className="menu__list-title">Clerk</div>,
        <div className="menu__item">
            <NavLink className={`${menuLinkClassName}`} onClick={()=>app.menuItemClick()} to={`${roleRoot}/NewLink`}>
                <images.PassengerNewOrder/>
                <span className="menu__name">New Application</span>
            </NavLink>
        </div>,
        <div className="menu__item">
            <NavLink className={`${menuLinkClassName}`} onClick={()=>app.menuItemClick()} to={`${roleRoot}/Submissions`}>
                <images.PassengerPastOrders/>
                <span className="menu__name">Submissions</span>
            </NavLink>
        </div>,
    ];
    return {
        name   : "Clerk",
        root   : roleRoot,
        items  : menuItems,
        routes : [
            <Route
                key={"clerk_newlink"}
                path={`${roleRoot}/NewLink`}
                element={<NewLink/>} />,
            <Route
                key={"clerk_submissions"}
                path={`${roleRoot}/Submissions`}
                element={<Submissions/>} />,
        ]
    };
}

export default Index;
